import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { PagedResults, PagingParams } from '@abaco/web-common/src/Paging';
import { WaterType, WaterOut, Water, WaterItem, WaterAction } from '../models/Water';
import { toHA } from '../models/Utils';

export default class WaterApi {

    private http: HTTPClient;
    private rootPath: string;

    constructor(http: HTTPClient, rootPath: string) {
        this.http = http;
        this.rootPath = rootPath
    }

    public async getWaterTypes(paging: PagingParams, filter: string | null): Promise<PagedResults<WaterType>> {
        const res = await this.http.get(`${this.rootPath}/v1/plots/dictionary_water_type`, {
            params: {
                offset: paging.offset,
                count: paging.count,
                filter: filter ? `^ds_water_type like ${filter.toUpperCase()}` : undefined
            }
        })
        return res.data;
    }

    public async getWaterItems(pkCuaa: number, pagingParams: PagingParams, filter: string | null): Promise<PagedResults<WaterItem>> {
        const filterArr = [];
        if (filter) {
            filterArr.push(`item_name like ${filter.toUpperCase()}`);
        }
        const res = await this.http.get(`/sitiagri-rest-api/api_basic/v1/warehouse/subjects/${pkCuaa}/waters`, {
            params: {
                offset: pagingParams.offset,
                count: pagingParams.count,
                filter: filterArr.length > 0 ? filterArr : undefined,
            }
        });
        return res.data;
    }

    public async addWater(subject_id: number, campaign: number, action_id: number, editedWater: WaterOut): Promise<Water> {
        const res = await this.http.post(`${this.rootPath}/v1/plots/subjects/${subject_id}/${campaign}/activities/${action_id}/waters`, editedWater);
        toHA(res.data, ["area_covered"]);
        return res.data;
    }
    public async addProtocolWater(pkCuaa: number, protocol_id: number, action_id: number, editedWater: Partial<WaterOut>): Promise<Water> {
        const res = await this.http.post(`${this.rootPath}/v1/protocols/subjects/${pkCuaa}/dictionary_protocols/${protocol_id}/activities/${action_id}/waters`, editedWater);
        return res.data;
    }

    public async editWater(subject_id: number, campaign: number, action_id: number, water_id: number, editedWater: WaterOut): Promise<Water> {
        const res = await this.http.put(`${this.rootPath}/v1/plots/subjects/${subject_id}/${campaign}/activities/${action_id}/waters/${water_id}`, editedWater);
        toHA(res.data, ["area_covered"]);
        return res.data;
    }
    public async editProtocolWater(pkCuaa: number, protocol_id: number, action_id: number, water_id: number, editedWater: Partial<WaterOut>): Promise<Water> {
        const res = await this.http.put(`${this.rootPath}/v1/protocols/subjects/${pkCuaa}/dictionary_protocols/${protocol_id}/activities/${action_id}/waters/${water_id}`, editedWater);
        return res.data;
    }

    public async editActionWater(subject_id: number, campaign: number, action_id: number, water_id: number, editedWater: WaterOut): Promise<WaterAction> {
        const res = await this.http.put(`${this.rootPath}/v1/plots/subjects/${subject_id}/${campaign}/actions/${action_id}/waters/${water_id}`, editedWater);
        toHA(res.data, ["area_covered"]);
        return res.data;
    }
    public async addActionWater(subject_id: number, campaign: number, action_id: number, newwater: WaterOut): Promise<WaterAction> {
        const res = await this.http.post(`${this.rootPath}/v1/plots/subjects/${subject_id}/${campaign}/actions/${action_id}/waters`, newwater);
        return res.data;
    }

    public async deleteActionWater(pk_cuaa: number, campaign: number, execution_id: number, item_id: number): Promise<Water> {
        const res = await this.http.delete(`${this.rootPath}/v1/plots/subjects/${pk_cuaa}/${campaign}/actions/${execution_id}/waters/${item_id}`);
        return res.data;
    }
}
